<template>
  <div class="DetailRemind">
    <div class="box">
      <div class="title">
        <img src="../../../assets/detail/lingdang.png" alt="">
        <span>开播时间：<span style="font-weight: 500">{{data.starttime | formatDate}}</span></span>
      </div>
      <div class="copy" @click="onCopy" ref="container">
        <span>电脑登录微信端打开链接</span>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from "@/common/js/data";

export default {
  name: "DetailRemind",
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  filters: {
    formatDate(time) {
      let date = new Date(time)
      return formatDate(date, 'yyyy年MM月dd日 hh:mm')
    }
  },
  methods: {
    onCopy() {
      let container = this.$refs.container
      this.$copyText(window.location.href, container)
      this.$toast('复制成功')
    }
  }
}
</script>

<style lang="scss" scoped>
.DetailRemind {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  .box {
    width: 700px;
    height: 150px;
    background: url("../../../assets/detail/kaiboshijian.png");
    background-size: 100% 100%;
    .copy {
      height: 40px;
      width: 325px;
      background: #FFFFFF;
      color: #00476C;
      font-size: 24px;
      border-radius: 26px;
      line-height: 40px;
      margin-left: 94px;
      margin-top: 10px;
    }
    .title {
      display: flex;
      color: #FFFFFF;
      font-size: 24px;
      align-items: center;
      margin-left: 50px;
      margin-top: 20px;
      img {
        width: 50px;
        height: 50px;
      }
    }
  }
}
</style>
